import { makeStyles } from 'tss-react/mui';

const useAddToOrderButtonStyles = makeStyles()((theme) => ({
  inOrder: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,
    },
  },
}));

export default useAddToOrderButtonStyles;
